module.exports = __webpack_public_path__ + "media/Header Video.f3330983.mp4";